import React, {useState, useEffect, useRef} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi"; 

const ClientEdit = ()=>{
     const [name, setName ] = useState('');
     const [email, setEmail ] = useState('');
     const [contactPhone, setContactPhone ] = useState('');
     const [contactEmail, setContactEmail ] = useState('');
     const [notificationMsisdn, setNotificationMsisdn ] = useState(''); 
    const [redirect, setRedirect] = useState(false); 

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`client/${id}`);
                 setName(data.name);
                 setEmail(data.email);
                 setContactPhone(data.contact_phone);
                 setContactEmail(data.contact_email);
                 setNotificationMsisdn(data.notification_msisdn); 
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`client/${id}`, {
            name,
            email,
             contact_phone:contactPhone,
            contact_email:contactEmail,
            notification_msisdn:notificationMsisdn,  
        });
        console.log(data);
        setRedirect(true);
    };
  
    if(redirect){
         return <Navigate to={'/client'} />
    }
    return (
        <Wrapper pageTitle={'Edit Client'}>
            <InnerNav createLink={'/clientCreate'} listLink={'/client'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Name </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Name" value={name}
                        onChange = {e => setName(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Email </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Email" value={email}
                        onChange = {e => setEmail(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ContactPhone </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ContactPhone" value={contactPhone}
                        onChange = {e => setContactPhone(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ContactEmail </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ContactEmail" value={contactEmail}
                        onChange = {e => setContactEmail(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">NotificationMsisdn </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="NotificationMsisdn" value={notificationMsisdn}
                        onChange = {e => setNotificationMsisdn(e.target.value)} />
                    </label>
 

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default ClientEdit;